import React from 'react';
import InputField from '../../Reusable/InputField';
import withTranslations from '../../../utils/HighOrderComponent';
import ComboBoxAutocomplete from '../../Reusable/ComboBoxAutocomplete';
import CheckboxGroupTwoChoices from '../../Reusable/CheckboxGroupTwoChoices';
import { Row, Col } from 'react-bootstrap';
import { checkIfUserHasAutonomousProvince } from '../../../utils';

const SecondStep = (props) => {
  const {
    t,
    signetForm,
    isElSignet,
    isOnNationalMinoritiesLanguage,
    isOnSerbianLatin,
    errors,
    loggedUser,
  } = props || {};
  const { Placeholders, Choices, Questions } = t || {};
  const signetSizeChoice2 = signetForm !== null ? signetForm === true : null;
  const nationalMinorityChoice1 =
    isOnNationalMinoritiesLanguage !== null
      ? isOnNationalMinoritiesLanguage === true
      : null;
  const nationalMinorityChoice2 =
    isOnNationalMinoritiesLanguage !== null
      ? isOnNationalMinoritiesLanguage === false
      : null;
  const serbianLatinChoice1 =
    isOnSerbianLatin !== null ? isOnSerbianLatin === true : null;
  const serbianLatinChoice2 =
    isOnSerbianLatin !== null ? isOnSerbianLatin === false : null;

  const showLanguage = checkIfUserHasAutonomousProvince(loggedUser);

  return (
    <Row>
      <Col md={6}>
        <div className="form-row col-md-12 mb-3">
          <CheckboxGroupTwoChoices
            question={Questions.signetForm}
            choice1Label={Choices.digital}
            choice2Label={Choices.imprintShape}
            handleCheckChoiceSet={props.handleCheckChoiceSet}
            name={'isElSignet'}
            value1={isElSignet}
            value2={signetSizeChoice2}
            disableChoice2
          />
        </div>
        {props.signetForm && (
          <ComboBoxAutocomplete
            data={props.signetSizes}
            changeValue={(newValue) =>
              props.changeComboAutocomplete('signetSize', newValue)
            }
            placeholder={Placeholders.signetSizes}
            text={(a) => a}
            required
            wholeObject
            updateValue={props.signetSize}
          />
        )}
        <InputField
          name="signetNumber"
          placeholder={Placeholders.signetNumber}
          required
          onChange={props.onChange}
          type="number"
          value={props.signetNumber}
          onlyPositive={true}
          error={errors?.signetNumber}
        />
        {!isElSignet && (
          <InputField
            name="ordinalNumber"
            placeholder={Placeholders.ordinalNumber}
            onChange={props.onChange}
            required={props.signetForm}
            value={props.ordinalNumber}
            disabled={props.signetForm === false}
          />
        )}
        <div className="form-group mt-3">
          <ComboBoxAutocomplete
            data={props.coatOfArmsAppearances}
            changeValue={(newValue) =>
              props.changeComboAutocomplete('coatOfArmsAppearance', newValue)
            }
            placeholder={Placeholders.coatOfArmsAppearance}
            text={(a) => a.text}
            required
            wholeObject
            updateValue={props.coatOfArmsAppearance}
            error={errors?.coatOfArmsAppearance}
          />
        </div>
      </Col>
      <Col md={6}>
        {showLanguage && (
          <div>
            <div className="form-group">
              <InputField
                name="languageAndScript"
                placeholder={Placeholders.languageAndScript}
                disabled
                onChange={props.onChange}
                value={props.languageAndScript}
              />
            </div>
            <div className="form-row col-md-12 mb-3">
              <CheckboxGroupTwoChoices
                question={Questions.signetScript}
                handleCheckChoiceSet={props.handleCheckChoiceSet}
                name={'isOnSerbianLatin'}
                value1={serbianLatinChoice1}
                value2={serbianLatinChoice2}
              />
            </div>
          </div>
        )}

        <div className="form-row col-md-12 mb-3">
          <CheckboxGroupTwoChoices
            question={Questions.nationalMinorities}
            handleCheckChoiceSet={props.handleCheckChoiceSet}
            name={'isOnNationalMinoritiesLanguage'}
            value1={nationalMinorityChoice1}
            value2={nationalMinorityChoice2}
          />
        </div>
        {props.isOnNationalMinoritiesLanguage && (
          <ComboBoxAutocomplete
            data={props.nationalMinorities}
            changeValue={(newValue) =>
              props.changeComboAutocomplete('nationalMinority', newValue)
            }
            placeholder={Placeholders.nationalMinorities}
            text={(a) => a.text}
            multiple
            wholeObject
            required
            updateValue={props.selectedNationalMinoitites}
          />
        )}
      </Col>
    </Row>
  );
};

export default withTranslations(SecondStep, 'SecondStep');
